namespace app.toolbar {
    'use strict';
    
    export class GestaoContaService {

        public ACCOUNTS_API_URL: string;

        /** @ngInject */
        public constructor(
            private $http: ng.IHttpService, 
            properties: app.support.constants.Properties){
            this.ACCOUNTS_API_URL = `${properties.apiUrl}/integracoes-identidades/api/acessos/contas/setores`;
        }

        public alterarContaAtual(setorId: string): ng.IPromise<any> {
            return this.$http.put(`${this.ACCOUNTS_API_URL}/${setorId}/atual`, {});  
        }
    }

    const SERVICE_NAME: string = "app.toolbar.alterar-conta.GestaoContaService";

    const config = /** @ngInject */(errorHandlerProvider, $provide) => {
        errorHandlerProvider.decorate($provide, SERVICE_NAME);
    }; 

    angular.module("app.toolbar").service(SERVICE_NAME, GestaoContaService).config(config);
}